import type {
  HierarchicalRuleset,
  HierarchicalRulesetConfigField,
  HierarchicalRulesetMetadata,
  HierarchicalRulesetMetadataField
} from '@library/types/rulesets';
import {
  RULESETS_CONFIG_FIELDS,
  RULESETS_METADATA_FIELDS
} from '@library/types/rulesets';
import { toUSD } from '@bo-utils/common';

export const isMetadataField = (
  key: string
): key is HierarchicalRulesetMetadataField =>
  RULESETS_METADATA_FIELDS.includes(key as HierarchicalRulesetMetadataField);

export const isConfigField = (
  key: string
): key is HierarchicalRulesetConfigField =>
  RULESETS_CONFIG_FIELDS.includes(key as HierarchicalRulesetConfigField);

export const formatNumericalValue = ({
  fieldName,
  value
}: {
  fieldName: string;
  value: number;
}) => {
  if (fieldName === 'refund_in_minutes') {
    return `${value} minutes`;
  }
  if (fieldName === 'in_game_multiplier') {
    return `${value}%`;
  }
  return toUSD(Number(Number(value) / 100));
};

export function getRulesetQualifiedPath(
  ruleset: HierarchicalRulesetMetadata | HierarchicalRuleset | undefined
) {
  return ruleset?.attributes?.qualified_path || '';
}
